import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "PreSeasonCard.title",
    defaultMessage: "Pre-season",
  },
  noPlans: {
    id: "PreSeasonCard.noPlans",
    defaultMessage: "No pre-season exercises yet",
  },
  activePlanSingular: {
    id: "PreSeasonCard.activePlanSingular",
    defaultMessage: "active plan",
  },
  activePlanPlural: {
    id: "PreSeasonCard.activePlanPlural",
    defaultMessage: "active plans",
  },
  manage: {
    id: "PreSeasonCard.manage",
    defaultMessage: "Design & track exercises",
  },
});
